export default "__VITE_ASSET__CSP5wMqV__"